import React, { useState } from 'react'
import Select from 'react-select'
import './DailyHoroscope.css'
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { toast } from 'react-toastify';
import { API_END_POINT, TOKEN } from '../../constant';
import { method } from 'lodash';
import Loader from '../Loader/Loader';

function DailyHoroscope() {

    const [selectedOption, setSelectedOption] = useState('');
    const [englishDescription, setEnglishDescription] = useState();
    const [hindiDescription, setHindiDescription] = useState('');
    const [gujaratiDescription, setGujaratiDescription] = useState();
    const [marathiDescription, setMarathiDescription] = useState();
    const [horoscopeDate, setHoroscopeDate] = useState(new Date())
    const [loading, setLoading] = useState(false)

    const rashiDetails = [
        { value: 1, label: "Aries" },
        { value: 2, label: "Taurus" },
        { value: 3, label: "Gemini" },
        { value: 4, label: "Cancer" },
        { value: 5, label: "Leo" },
        { value: 6, label: "Virgo" },
        { value: 7, label: "Libra" },
        { value: 8, label: "Scorpio" },
        { value: 9, label: "Sagittarius" },
        { value: 10, label: "Capricorn" },
        { value: 11, label: "Aquarius" },
        { value: 12, label: "Pisces" }
    ];

    const customStyles = {
        menu: (provided) => ({
            ...provided,
            zIndex: 9999,
        }),
    };

    const addDailyHoroscopeData = async () => {
        setLoading(true)
        const createdOnFormattedData = moment(horoscopeDate).format('DD/MM/YYYY')
        const addDailyHoroscopeUrl = `${API_END_POINT}dailyHoroscope/addNewDailyHoroscope`
        const addDailyHoroscopeHeaders = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${TOKEN}`,
        }

        const dailyHoroscopeData = {
            'rashiId': selectedOption,
            'horoscopeDescriptionEnglish': englishDescription,  
            'horoscopeDescriptionHindi': hindiDescription,
            'horoscopeDescriptionMarathi': marathiDescription,
            'horoscopeDescriptionGujarati': gujaratiDescription,
            'requestHoroscopeDate': createdOnFormattedData
        }

        try {
            const response = await fetch(addDailyHoroscopeUrl, { 
                method: 'POST', 
                headers: addDailyHoroscopeHeaders, 
                body: JSON.stringify(dailyHoroscopeData) 
            })

            if (!response.ok) {
                toast.error('failed to add horoscope data')
                return
            }

            toast.success('horoscope data added successfully')
            setHoroscopeDate(new Date ())
            setEnglishDescription('')
            setHindiDescription('')
            setGujaratiDescription('')
            setMarathiDescription('')

        } catch (error) {
            console.log("error adding horoscope data --->>> addDailyHoroscopeData() " , error)
        } finally {
            setLoading(false)
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("clikced buttonk") 
        if (!selectedOption || !hindiDescription || !englishDescription || !gujaratiDescription || !marathiDescription || !horoscopeDate) {
            toast.error("fields cannot be null")
            return
        }
        // const createdOnFormattedData = moment(horoscopeDate).format('DD/MM/YYYY')
        // console.log("rashiId : - ", selectedOption)
        // console.log("horocope date : - ", createdOnFormattedData)
        // console.log("english description : - ", englishDescription)
        // console.log("hindi description : - ", hindiDescription)
        // console.log("marathi description : - ", marathiDescription)
        // console.log("gujarati description : - ", gujaratiDescription)
        addDailyHoroscopeData();

    }

    const handleElementSelect = (e) => {
        setSelectedOption(e.value)
        console.log("this is the value ", e.value)
    }


    return (
        <main className='main'>
            {loading ? (
                <Loader />
            ) : (
                <>
                    <h3>Daily Horoscope</h3>
                    <div className='dailyhoroscopecontainer' >
                        <div className="App">
                            <Select
                                defaultValue={selectedOption}
                                onChange={handleElementSelect}
                                options={rashiDetails}
                                styles={customStyles}
                            />
                        </div>
                        <div>
                            <label htmlFor="dailyhoroscopedate">Horoscope Date</label>
                            <DatePicker id='fileupload' selected={horoscopeDate} onChange={date => setHoroscopeDate(date)} dateFormat='dd/MM/yyyy' showYearDropdown scrollableYearDropdown />
                        </div>
                        <textarea className='horoscopeTextBox'
                            name="english horoscope" id="english description"
                            onChange={(e) => (setEnglishDescription(e.target.value))}
                            value={englishDescription}
                            placeholder='English Description here....' >
                        </textarea>
                        <textarea className='horoscopeTextBox'
                            name="hindi horoscope" id="hindi description"
                            onChange={(e) => (setHindiDescription(e.target.value))}
                            value={hindiDescription}
                            placeholder='Hindi Description here....' >
                        </textarea>
                        <textarea className='horoscopeTextBox'
                            name="marathi horoscope" id="marathi description"
                            onChange={(e) => (setMarathiDescription(e.target.value))}
                            value={marathiDescription}
                            placeholder='marathi Description here....' >
                        </textarea>
                        <textarea className='horoscopeTextBox'
                            name="gujarati horoscope" id="gujarati description"
                            onChange={(e) => (setGujaratiDescription(e.target.value))}
                            value={gujaratiDescription}
                            placeholder='gujarati Description here....' >
                        </textarea>
                        <button type="submit" onClick={handleSubmit} className='horoscopeButton' >Add Horoscope</button>

                    </div>
                </>
            )}
        </main>
    )
}

export default DailyHoroscope
